import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "kanban-user-filter"
}
const _hoisted_2 = ["title", "onClick"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  key: 1,
  class: "kanban-user-filter__initials"
}

import {ref, watch} from 'vue';

interface UserItem {
    userId: number;
    userName: string;
    thumbnail: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'KanbanUserFilter',
  props: {
    users: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const selectedIds = ref<number[]>([...props.modelValue]);

watch(() => props.modelValue, (val) => {
    selectedIds.value = [...val];
});

const COLORS = [
    '#1565C0', '#E65100', '#2E7D32', '#6A1B9A',
    '#C62828', '#00838F', '#4E342E', '#37474F',
    '#AD1457', '#283593', '#1B5E20', '#BF360C',
];

// Default avatar is a very small base64 (~300 chars). Real thumbnails are much larger.
function isDefaultAvatar(thumbnail: string): boolean {
    return !thumbnail || thumbnail.length < 500;
}

function getInitials(name: string): string {
    if (!name) return '?';
    const parts = name.trim().split(/\s+/);
    if (parts.length >= 2) {
        return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return parts[0].substring(0, 2).toUpperCase();
}

function getColor(userId: number): string {
    return COLORS[Math.abs(userId) % COLORS.length];
}

function isSelected(userId: number) {
    return selectedIds.value.includes(userId);
}

function toggle(userId: number) {
    const idx = selectedIds.value.indexOf(userId);
    if (idx >= 0) {
        selectedIds.value.splice(idx, 1);
    } else {
        selectedIds.value.push(userId);
    }
    emit('update:modelValue', [...selectedIds.value]);
}

function clearAll() {
    selectedIds.value = [];
    emit('update:modelValue', []);
}

return (_ctx: any,_cache: any) => {
  return (__props.users.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["kanban-user-filter__btn kanban-user-filter__btn--all", {'kanban-user-filter__btn--active': selectedIds.value.length === 0}]),
          onClick: clearAll
        }, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("i", { class: "fa fa-user-o" }, null, -1 /* CACHED */)
        ]))], 2 /* CLASS */),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.users, (user) => {
          return (_openBlock(), _createElementBlock("button", {
            key: user.userId,
            type: "button",
            class: _normalizeClass(["kanban-user-filter__btn", {'kanban-user-filter__btn--active': isSelected(user.userId)}]),
            style: _normalizeStyle(isDefaultAvatar(user.thumbnail) ? {backgroundColor: getColor(user.userId)} : undefined),
            title: user.userName,
            onClick: ($event: any) => (toggle(user.userId))
          }, [
            (!isDefaultAvatar(user.thumbnail))
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: user.thumbnail,
                  alt: user.userName,
                  class: "kanban-user-filter__img"
                }, null, 8 /* PROPS */, _hoisted_3))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(getInitials(user.userName)), 1 /* TEXT */))
          ], 14 /* CLASS, STYLE, PROPS */, _hoisted_2))
        }), 128 /* KEYED_FRAGMENT */))
      ]))
    : _createCommentVNode("v-if", true)
}
}

})